// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2raUK","header":"PatientQuestionnaire_header__Cw3Vx","info":"PatientQuestionnaire_info__2jrar"};